import { WebSocketReceiveMessage } from './web-socket-receive-message';

export type DeletedBrandProductMap = { brandId: string; id: string };

export class WebSocketBrandProductMapsDeleted extends WebSocketReceiveMessage {
  override payload: DeletedBrandProductMap[];

  override onDeserialize() {
    super.onDeserialize();
    const incoming: any[] = Array.isArray(this.payload) ? this.payload : [this.payload];
    this.payload = incoming.filter(Boolean);
  }
}
